'use strict';

angular.module('inara').factory('CallsService', CallsService);

var defaults = require('../../defaults/Defaults');
var log = require('../../log/Log').channel('CallsService');
require('./RoomService');
var sutl = require('../../sutl/Sutl');

CallsService.$inject = [
    '$rootScope',
    '$interval',
    'KayleeService',
    'RoomService',
    '$timeout',
    '$ionicPopup',
    'gettextCatalog',
];

function CallsService(
    $rootScope,
    $interval,
    KayleeService,
    RoomService,
    $timeout,
    $ionicPopup,
    gettextCatalog
) {
    var room = null;
    var site = null;
    var activeCalls = [];
    var recentCalls = null;
    var activeCallCount = 0;
    var directory = null;
    var invalidNumberPopupDuration = 10000;

    log.info('initializing');
    RoomService.onOnlineChanged(onRoomServiceOnlineChanged);
    startCallTimer();

    return {
        getActiveCalls: function () {
            return activeCalls;
        },
        getBestAvailableCallTypeByClass: getBestAvailableCallTypeByClass,
        getRecentCalls: function () {
            return recentCalls;
        },
        getActiveCallCount: function () {
            return activeCallCount;
        },
        placeCallByClass: placeCallByClass,
        placeCallByType: placeCallByType,
        inviteToCall: inviteToCall,
        hangupAllCalls: hangupAllCalls,
        canCallClass: canCallClass,
        canCallType: canCallType,
        hasCallCapsClass: hasCallCapsClass,
        hasCallCapsType: hasCallCapsType,
        hasConfiguredCallCapsClass: hasConfiguredCallCapsClass,
        hasConfiguredCallCapsType: hasConfiguredCallCapsType,
        getExceededMaxCallsStringByClass: getExceededMaxCallsStringByClass,
        getExceededMaxCallsStringByType: getExceededMaxCallsStringByType,
        getNumConfiguredCallTypesForClass: getNumConfiguredCallTypesForClass,
        getUnsupportedCallTypeString: getUnsupportedCallTypeString,
        getUnsupportedCallClassString: getUnsupportedCallClassString,
    };

    function shouldDialMeetingCodes() {
        // TODO: update this to something better when we support multiple
        // controllers
        return process.env.appEnv === 'cordova' || RoomService.isUiPreview();
    }

    function onRoomServiceOnlineChanged(online) {
        log.debug('onRoomServiceOnlineChanged: ' + online);

        if (online) {
            room = RoomService.getRoom();
            site = KayleeService.getSite(room.siteId);
            recentCalls = room.$getCalls(defaults.inara.numRecentCalls);
            recentCalls.$onChildAdded(onRecentCallAdded);
            recentCalls.$onChildChanged(onRecentCallChanged);
            directory = room.$getDirectory();
        } else {
            activeCalls.length = 0;
            room = null;
            site = null;

            if (recentCalls !== null) {
                recentCalls.$offChildChanged(onRecentCallChanged);
                recentCalls.$offChildAdded(onRecentCallAdded);
            }

            recentCalls = null;
            directory = null;
        }
    }

    function onRecentCallAdded(key) {
        handleCallChanged(key);
    }

    function onRecentCallChanged(key) {
        handleCallChanged(key);
    }

    function handleCallChanged(key) {
        var call = recentCalls.$recordAt(key);
        var found = false;
        var foundIndex;

        for (var i = 0; i < activeCalls.length; i++) {
            if (activeCalls[i].$id === key) {
                found = true;
                foundIndex = i;
                break;
            }
        }

        if (found && call.callState === 'disconnected') {
            activeCalls.splice(foundIndex, 1);

            if (call.$meetingCodeDelayPromise !== null) {
                $timeout.cancel(call.$meetingCodeDelayPromise);
                call.$meetingCodeDelayPromise = null;
            }
            if (call.$meetingCodePromise !== null) {
                $timeout.cancel(call.$meetingCodePromise);
                call.$meetingCodePromise = null;
            }
            clearActiveMeetingCode(call);

            if (
                call.hasOwnProperty('callExtendedState') &&
                call.callExtendedState === 'invalidDialString'
            ) {
                var invalidNumberTimeout = null;
                var invalidNumberPopup = $ionicPopup.show({
                    template:
                        'The ' +
                        (call.callType === 'zoom' ? 'meeting ID' : 'number') +
                        ': ' +
                        call.dialString +
                        ' was invalid. Please confirm and try again.',
                    buttons: [
                        {
                            text: 'OK',
                            type: 'button-card-highlight',
                            onTap: function (e) {
                                if (invalidNumberTimeout !== null) {
                                    $timeout.cancel(invalidNumberTimeout);
                                    invalidNumberTimeout = null;
                                }
                                invalidNumberPopup.close();
                            },
                        },
                    ],
                });
                invalidNumberTimeout = $timeout(function () {
                    if (invalidNumberPopup) invalidNumberPopup.close();
                }, invalidNumberPopupDuration);
            }
        } else if (!found && call.callState !== 'disconnected') {
            if (
                shouldDialMeetingCodes() &&
                call.callType !== 'zoom' &&
                call.hasOwnProperty('meetingCodes')
            ) {
                call.$dialMeetingCodesOnConnect = true;
            }

            call.$answer = function () {
                room.$requestAnswer(key);
            };

            call.$consentToRecording = function (consent) {
                room.$requestConsentToRecording(key, consent);
            };

            call.$dial = function (value) {
                room.$requestDial(key, value);
            };

            call.$hangup = function (hangupMethodPromise) {
                // Takes an optional hangupMethodPromise, typically supplied
                // by a UI controller which will gather the user input to
                // select a hangup method.
                if (angular.isDefined(hangupMethodPromise) && hangupMethodPromise !== null) {
                    hangupMethodPromise
                        .then(function (result) {
                            if (result === 'endmeeting') {
                                room.$requestHangup(key, true);
                            } else if (result === 'hangup') {
                                room.$requestHangup(key);
                            } else {
                                log.debug(
                                    "hangupMethodPromise resolved to: '" +
                                        result +
                                        "', canceling hangup request"
                                );
                            }
                        })
                        .catch(function (error) {
                            log.error('$hangup() error: ' + error);
                        });
                } else {
                    room.$requestHangup(key);
                }
            };

            call.$reject = function () {
                room.$requestReject(key);
            };

            if (call.hasOwnProperty('receiveGain')) {
                call.$setReceiveGain = function (value) {
                    room.$requestReceiveGain(key, value);
                }.bind(call);
            }

            // hook up if call was just added, such as in remote control
            hookUpCallSendVideo(key, call);
            hookUpCallParticipantMute(key, call);

            // match up to a directory entry, if any

            if (directory !== null) {
                var foundDir = false;
                for (var j = 0; j < directory.length; j++) {
                    var contactKeys = Object.keys(directory[j].contacts);
                    for (var k = 0; k < contactKeys.length; k++) {
                        if (directory[j].contacts[contactKeys[k]].number === call.dialString) {
                            call.$contactPicture = directory[j].picture;
                            foundDir = true;
                            break;
                        }
                    }
                    if (foundDir) break;
                }
            }

            activeCalls.push(call);
        } else if (call.callState === 'connected') {
            // hook up if call has just connected
            hookUpCallSendVideo(key, call);
            hookUpCallParticipantMute(key, call);

            if (shouldDialMeetingCodes() && call.$dialMeetingCodesOnConnect === true) {
                delete call.$dialMeetingCodesOnConnect;

                if (
                    angular.isDefined(call.dialPrefix) &&
                    site.settings.telephonyDialingPrefixDelay > 0
                ) {
                    // delay sending meeting codes, if any, until after
                    // dialing prefix delay has passed
                    call.$meetingCodeDelayPromise = $timeout(function () {
                        dialMeetingCodes(call);
                    }, site.settings.telephonyDialingPrefixDelay * 1000);
                } else {
                    // send meeting codes, if any
                    dialMeetingCodes(call);
                }
            }
        }

        var prevActiveCallCount = activeCallCount;

        activeCallCount = activeCalls.length;

        if (activeCallCount !== prevActiveCallCount) {
            $rootScope.$broadcast('CallsServiceActiveCallCountChanged');
        }
    }

    function hookUpCallSendVideo(callKey, call) {
        if (angular.isDefined(call.sendingVideo) && !angular.isDefined(call.$setSendVideo)) {
            call.$setSendVideo = function (value) {
                room.$requestSendVideo(callKey, value);
            }.bind(call);
        }
    }

    function hookUpCallParticipantMute(callKey, call) {
        if (!angular.isDefined(call.$setParticipantAudioMute)) {
            call.$setParticipantAudioMute = function (participantId, mute) {
                room.$requestMuteParticipant(callKey, participantId, mute);
            }.bind(call);
        }

        if (!angular.isDefined(call.$setParticipantVideoMute)) {
            call.$setParticipantVideoMute = function (participantId, mute) {
                room.$requestMuteParticipantVideo(callKey, participantId, mute);
            }.bind(call);
        }
    }

    function dialMeetingCodes(call) {
        var keys = Object.keys(call.meetingCodes).sort();
        var meetingCodeIndex = 0;
        if (keys.length > 0) {
            delete call.activeMeetingCode;
            call.$save().then(function () {
                call.$meetingCodePromise = $timeout(
                    dialMeetingCodeHelper,
                    defaults.inara.meetingCodeSendDelay
                );
            });
        }

        function dialMeetingCodeHelper() {
            if (meetingCodeIndex < keys.length && call.callState === 'connected') {
                var key = keys[meetingCodeIndex];
                dialMeetingCodeByKey(call, key);
                meetingCodeIndex++;
                if (meetingCodeIndex < keys.length && call.callState === 'connected') {
                    call.$meetingCodePromise = $timeout(
                        dialMeetingCodeHelper,
                        defaults.inara.meetingCodeSendDelay
                    );
                } else {
                    call.$meetingCodePromise = null;
                    $timeout(function () {
                        clearActiveMeetingCode(call);
                    }, defaults.inara.meetingCodeSendDelay);
                }
            }
        }

        function dialMeetingCodeByKey(call, meetingCodeKey) {
            log.debug(
                'dialing meeting code ' +
                    meetingCodeKey +
                    ", '" +
                    call.meetingCodes[meetingCodeKey] +
                    "'"
            );
            call.activeMeetingCode = meetingCodeKey;
            call.$save().then(function () {
                call.$dial(call.meetingCodes[meetingCodeKey]);
            });
        }
    }

    function clearActiveMeetingCode(call) {
        if (call.hasOwnProperty('activeMeetingCode')) {
            delete call.activeMeetingCode;
            call.$save();
        }
    }

    function getBestAvailableCallTypeByClass(callClass) {
        for (var i = 0; i < KayleeService.callTypes.length; i++) {
            var callType = KayleeService.callTypes[i];
            if (callClass === KayleeService.getCallClass(callType) && canCallType(callType)) {
                return callType;
            }
        }

        return null;
    }

    function placeCallByType(callMethod) {
        if (!RoomService.online()) return;

        if (canCallType(callMethod.callType)) {
            room.$requestCall(angular.extend({}, callMethod));
        }
    }

    function placeCallByClass(callMethod) {
        if (!RoomService.online()) return;

        var callType = getBestAvailableCallTypeByClass(callMethod.callClass);
        var cm = angular.extend({}, callMethod);
        cm.callType = callType;
        delete cm.callClass;
        room.$requestCall(cm);
    }

    function inviteToCall(call, invitees) {
        if (!RoomService.online()) return;

        room.$requestInviteToCall(call.$id, invitees);
    }

    function hangupAllCalls() {
        angular.forEach(recentCalls, function (call) {
            if (call.callState === 'connected') {
                call.$hangup();
            }
        });
    }

    function hasCallCapsClass(callClass) {
        if (!RoomService.online()) return false;

        for (var i = 0; i < KayleeService.callTypes.length; i++) {
            var callType = KayleeService.callTypes[i];
            if (
                KayleeService.getCallClass(callType) === callClass &&
                sutl.getNode(room, ['caps', 'maxCalls', callType], 0) > 0
            ) {
                return true;
            }
        }

        return false;
    }

    function hasCallCapsType(callType) {
        if (!RoomService.online()) return false;
        return sutl.getNode(room, ['caps', 'maxCalls', callType], 0) > 0;
    }

    function hasConfiguredCallCapsClass(callClass) {
        if (!RoomService.online()) return false;

        for (var i = 0; i < KayleeService.callTypes.length; i++) {
            var callType = KayleeService.callTypes[i];
            if (
                KayleeService.getCallClass(callType) === callClass &&
                sutl.getNode(room, ['configuredCaps', 'maxCalls', callType], 0) > 0
            ) {
                return true;
            }
        }

        return false;
    }

    function hasConfiguredCallCapsType(callType) {
        if (!RoomService.online()) return false;
        return sutl.getNode(room, ['configuredCaps', 'maxCalls', callType], 0) > 0;
    }

    function canCallClass(callClass) {
        if (!RoomService.online()) return false;

        for (var i = 0; i < KayleeService.callTypes.length; i++) {
            var callType = KayleeService.callTypes[i];
            if (KayleeService.getCallClass(callType) === callClass && canCallType(callType)) {
                return true;
            }
        }

        return false;
    }

    function canCallType(callType) {
        if (!RoomService.online()) return false;

        var numActiveCalls = 0;

        for (var i = 0; i < activeCalls.length; i++) {
            if (activeCalls[i].callType === callType) {
                numActiveCalls++;
            }
        }

        return (
            sutl.getNode(room, ['caps', 'maxCalls', callType], 0) -
                sutl.getNode(room, ['caps', 'disabledCalls', callType], 0) -
                numActiveCalls >
            0
        );
    }

    function startCallTimer() {
        $interval(function () {
            var now = Date.now();
            angular.forEach(activeCalls, function (call, id) {
                call.$callTimer = now - call.start;
            });
        }, 1000);
    }

    function getCallClassLabel(callClass) {
        switch (callClass) {
            case 'audio':
                /// Label for audio call type
                return gettextCatalog.getString('audio');
            case 'video':
                /// Label for video call type
                return gettextCatalog.getString('video');
            default:
                /// Label for unknown call type
                return gettextCatalog.getString('Unknown');
        }
    }

    function getCallTypeLabel(callType) {
        switch (callType) {
            case 'zoom':
                /// Label for Zoom call type
                return gettextCatalog.getString('Zoom');
            case 'teams':
                /// Label for Teams call type
                return gettextCatalog.getString('Teams');
            case 'audio':
                /// Label for audio call type
                return gettextCatalog.getString('audio');
            case 'video':
                /// Label for video call type
                return gettextCatalog.getString('video');
            default:
                /// Label for unknown call type
                return gettextCatalog.getString('Unknown');
        }
    }

    function getExceededMaxCallsStringByClass(callClass) {
        if (hasConfiguredCallCapsClass(callClass) && !hasCallCapsClass(callClass)) {
            /// callClass will be one of: [audio, video]
            return gettextCatalog.getString(
                'The {{callClass}} conferencing system may not be ' +
                    'functioning correctly. Please contact the room administrator.',
                { callClass: getCallClassLabel(callClass) }
            );
        }

        /// callClass will be one of: [audio, video]
        return gettextCatalog.getString(
            'All {{callClass}} lines are in use.' +
                ' Please hang up a call, then try calling again.',
            { callClass: getCallClassLabel(callClass) }
        );
    }

    function getExceededMaxCallsStringByType(callType) {
        return getExceededMaxCallsStringByClass(KayleeService.getCallClass(callType));
    }

    function getNumConfiguredCallTypesForClass(callClass) {
        return Object.keys(sutl.getNode(room, ['configuredCaps', 'maxCalls'], {})).reduce(function (
            acc,
            curr
        ) {
            return sutl.getNode(room, ['configuredCaps', 'maxCalls', curr], 0) > 0 &&
                KayleeService.getCallClass(curr) === 'video'
                ? acc + 1
                : acc;
        },
        0);
    }

    function getUnsupportedCallClassOrTypeString(callLabel) {
        /// callLabel will be one of: [audio, video, Zoom, Teams]
        return gettextCatalog.getString(
            'This room does not support {{callLabel}} calls.' +
                ' Please try dialing another type of call.',
            { callLabel: callLabel }
        );
    }

    function getUnsupportedCallClassString(callClass) {
        return getUnsupportedCallClassOrTypeString(getCallClassLabel(callClass));
    }

    function getUnsupportedCallTypeString(callType) {
        return getUnsupportedCallClassOrTypeString(getCallTypeLabel(callType));
    }
}

module.exports = CallsService;
